module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NW26_1SC_GSK.8688e342.png";